<script>
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';
import whatsappQrChannel from 'dashboard/api/channel/whatsappQr';

const POLL_INTERVAL_MS = 4000;

export default {
  components: {
    PageHeader,
    NextButton,
  },
  data() {
    return {
      name: '',
      isCreating: false,
      instanceName: null,
      qrDataUrl: null,
      connected: false,
      phoneNumber: null,
      inboxId: null,
      errorMessage: '',
      pollTimer: null,
    };
  },
  beforeUnmount() {
    this.stopPolling();
  },
  methods: {
    async createConnection() {
      if (!this.name.trim()) {
        this.errorMessage = this.$t(
          'INBOX_MGMT.ADD.WHATSAPP_QR.CHANNEL_NAME.ERROR'
        );
        return;
      }
      this.errorMessage = '';
      this.isCreating = true;
      try {
        const response = await whatsappQrChannel.create({
          name: this.name.trim(),
        });
        this.instanceName = response.data.instance_name;
        this.startPolling();
      } catch (error) {
        useAlert(
          error?.response?.data?.error ||
            this.$t('INBOX_MGMT.ADD.WHATSAPP_QR.ERROR_MESSAGE')
        );
      } finally {
        this.isCreating = false;
      }
    },
    startPolling() {
      this.poll();
      this.pollTimer = setInterval(this.poll, POLL_INTERVAL_MS);
    },
    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    async poll() {
      try {
        const response = await whatsappQrChannel.show(this.instanceName);
        const data = response.data;
        this.qrDataUrl = data.qr_base64;
        this.connected = data.connected;
        this.phoneNumber = data.phone_number;
        this.inboxId = data.inbox_id;
        if (this.connected) {
          this.stopPolling();
        }
      } catch (error) {
        // Silencioso: seguimos reintentando en el próximo ciclo.
      }
    },
    goToAgents() {
      router.replace({
        name: 'settings_inboxes_add_agents',
        params: {
          page: 'new',
          inbox_id: this.inboxId,
        },
      });
    },
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.WHATSAPP_QR.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.WHATSAPP_QR.DESC')"
    />

    <form
      v-if="!instanceName"
      class="flex flex-wrap flex-col mx-0"
      @submit.prevent="createConnection()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: errorMessage }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.CHANNEL_NAME.LABEL') }}
          <input
            v-model="name"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP_QR.CHANNEL_NAME.PLACEHOLDER')
            "
          />
          <span v-if="errorMessage" class="message">{{ errorMessage }}</span>
        </label>
      </div>

      <div class="w-full mt-4">
        <NextButton
          :is-loading="isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP_QR.SUBMIT_BUTTON')"
        />
      </div>
    </form>

    <div v-else class="flex flex-col items-center gap-4 mt-4">
      <template v-if="connected">
        <div
          class="flex flex-col items-center gap-2 p-6 rounded-xl bg-n-alpha-1"
        >
          <span class="text-3xl">✅</span>
          <p class="text-lg font-medium text-n-slate-12">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.CONNECTED.TITLE') }}
          </p>
          <p v-if="phoneNumber" class="text-n-slate-11">
            {{ phoneNumber }}
          </p>
        </div>
        <NextButton
          solid
          blue
          :disabled="!inboxId"
          :label="$t('INBOX_MGMT.ADD.WHATSAPP_QR.CONNECTED.CONTINUE')"
          @click="goToAgents"
        />
      </template>
      <template v-else>
        <p class="text-n-slate-11 text-center max-w-sm">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.SCAN.INSTRUCTIONS') }}
        </p>
        <div
          class="flex items-center justify-center w-64 h-64 rounded-xl border border-n-weak bg-white"
        >
          <img
            v-if="qrDataUrl"
            :src="qrDataUrl"
            :alt="$t('INBOX_MGMT.ADD.WHATSAPP_QR.SCAN.QR_ALT')"
            class="w-56 h-56"
          />
          <p v-else class="text-n-slate-10 text-sm px-4 text-center">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP_QR.SCAN.LOADING') }}
          </p>
        </div>
      </template>
    </div>
  </div>
</template>
